(function () {
    'use strict';

    angular
        .module('app')
        .factory('FileSelectorService', FileSelectorService);

    FileSelectorService.$inject = ['$q', '$timeout', 'DialogService'];

    /**
     * @ngdoc service
     * @name FileSelectorService
     * 
     * @description
     * Shows a file selector
     */
    function FileSelectorService($q, $timeout, DialogService) {
        var service = {
            selectLocalFileDialog: selectLocalFileDialog,
            selectChilliDocsFileDialog: selectChilliDocsFileDialog
        };

        return service;

        /*
         * Display a dialog for selecting a file or files from the local file system.
         *
         * @param {bool} multipleFiles - True if multiple files may be selected, False if only one file may be selected.
         * @param {Array} acceptFileTypes - An array of strings for accepted file types. E.g. ['docx', 'pdf']. Note that MS Edge doesn't
         *                                  support this as of 07/03/2017.
         *
         * @returns {Promise} A promise that resolves if a file or files were selected.
         *                    Resolves an array of selected files from the local file system, each element is
         *                    an object with the following properties:
         *                    {File} File
         *                    {string} FileName
         */
        function selectLocalFileDialog(multipleFiles, acceptFileTypes) {
            var deferred = $q.defer();
            var i;

            var fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');

            if (multipleFiles) {
                fileInput.multiple = true;
            }

            var fileTypes = [];
            if (acceptFileTypes && acceptFileTypes.length > 0) {
                for (i = 0; i < acceptFileTypes.length; i++) {
                    var fileType = acceptFileTypes[i].toLowerCase();
                    if (fileType.indexOf('.') !== 0) {
                        fileType = '.' + fileType;
                    }
                    fileTypes.push(fileType);
                }

                fileInput.accept = fileTypes.join(',');
            }

            fileInput.addEventListener('change', function () {
                var files = [];
                var rejectedFiles = [];

                for (i = 0; i < fileInput.files.length; i++) {
                    if (fileTypes.length > 0) {
                        if (!_.any(fileTypes, function (extension) { return _.endsWith(fileInput.files[i].name.toLowerCase(), extension); })) { // jshint ignore:line
                            rejectedFiles.push(fileInput.files[i].name);
                        }
                    }

                    files.push({
                        File: fileInput.files[i],
                        FileName: fileInput.files[i].name,
                        FileSize: fileInput.files[i].size
                    });
                }

                if (rejectedFiles.length > 0) {
                    var rejectedFileMessage = '';
                    if (rejectedFiles.length === 1) {
                        rejectedFileMessage = '<p>The selected file "' + rejectedFiles[0] + '" was not a valid file type.</p>';
                    } else {
                        rejectedFileMessage = '<p>The following selected files are not a valid file type.</p>';
                        rejectedFileMessage += '<ul>';
                        _.forEach(rejectedFiles, function (rejectedFile) {
                            rejectedFileMessage += '<li>' + rejectedFile + '</li>';
                        });
                        rejectedFileMessage += '</ul>';
                    }

                    rejectedFileMessage += '<p>Expected one of the following file types:</p>';
                    rejectedFileMessage += '<ul>';
                    _.forEach(fileTypes, function (extension) {
                        rejectedFileMessage += '<li>' + extension +'</li>';
                    });
                    rejectedFileMessage += '</ul>';

                    DialogService.alertHtml(rejectedFileMessage);

                    deferred.reject('Selection includes invalid file types.');
                } else {
                    deferred.resolve(files);
                }
            }, false);

            var mouseEvent = document.createEvent('MouseEvents');
            mouseEvent.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);

            $timeout(function () {
                fileInput.dispatchEvent(mouseEvent);
            }, 0);

            return deferred.promise;
        }

        /*
         * Display a dialog for selecting a file or files from those stored within ChilliDocs.
         *
         * @param {number} entityId - Entity id which will be used for default file filtering.
         *
         *
         * @returns {Promise} A promise that resolves if a file or files were selected.
         *                    Resolves an array of selected files.
         */
        function selectChilliDocsFileDialog(entityId) {
            return DialogService.show({
                locals: {
                    entityId: entityId
                },
                controller: 'FileSelectorDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/fileselection/file-selector-dialog.tmpl.html',
                size: DialogService.sizes.extraLargeFixedHeight
            });
        }
    }
})();